export enum TypeOfInference {
  UploadLora = "upload_lora",
  Checkpoint = "checkpoint",
  Inference = "inference",
}
